import { useNode } from "@craftjs/core";
import { useRouter } from "next/router";
import * as React from "react";
import { useTranslation } from "react-i18next";
import type { SponsorLayout } from "src/types";

import { Stars } from "@/components/icons/stars";
import SyncedListNotice from "@/components/import-list/synced-list-notice-component";

type SyncedSponsorsSettingsProps = {
  minimal?: boolean;
};

const getMessage = (layout: SponsorLayout | undefined) => {
  switch (layout) {
    case "golden":
      return "preference-panel.sponsors.embedded-golden-sponsors-synced";
    case "silver":
      return "preference-panel.sponsors.embedded-silver-sponsors-synced";
    case "bronze":
      return "preference-panel.sponsors.embedded-bronze-sponsors-synced";
    default:
      return "preference-panel.sponsors.embedded-sponsors-synced";
  }
};

const getTitle = (layout: SponsorLayout | undefined) => {
  switch (layout) {
    case "golden":
      return "preference-panel.block-display-name.golden-sponsors-synced";
    case "silver":
      return "preference-panel.block-display-name.silver-sponsors-synced";
    case "bronze":
      return "preference-panel.block-display-name.bronze-sponsors-synced";
    default:
      return "preference-panel.block-display-name.sponsors-synced";
  }
};

export default function SyncedSponsorsSettings({
  minimal,
}: SyncedSponsorsSettingsProps) {
  const { t } = useTranslation();
  const { query } = useRouter();
  const slug = query.slug as string;

  const { layout } = useNode<{ layout: SponsorLayout | undefined }>((node) => {
    return { layout: node.props?.layout };
  });

  const message = getMessage(layout);
  const title = getTitle(layout);

  return (
    <SyncedListNotice
      title={t(title)}
      icon={Stars}
      path="sponsors"
      eventSlug={slug}
      minimal={minimal}
    >
      {t(message)}
    </SyncedListNotice>
  );
}
